import React, { useCallback, useRef } from 'react';
import { ColDef } from 'ag-grid-community';
import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { PayoutItem } from '../../models/PayoutDetail';

interface PayoutItemsAgGridTableProps {
  items: PayoutItem[];
  columnDefs: ColDef[];
  isLoading?: boolean;
  isFetching?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

export const PayoutItemsAgGridTable = React.memo(function PayoutItemsAgGridTable({
  items,
  columnDefs,
  isLoading = false,
  isFetching = false,
  sorting,
  onSortingChange,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
}: PayoutItemsAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);

  // 🎯 Evitar crash: handler no-op para onGridReady
  const handleGridReady = useCallback(() => {}, []);

  return (
    <div className={`w-full ${isFetching && !isFetchingNextPage ? 'opacity-50 pointer-events-none' : ''}`}>
      <AgGridTable
        ref={agGridRef}
        data={items}
        columnDefs={columnDefs}
        height="calc(100vh - 400px)"
        enableSelection={false}
        isLoading={isLoading}
        onGridReady={handleGridReady}
        className="rounded-lg shadow-sm"
        gridOptions={{}} // Pasamos un objeto vacío para evitar conflictos
        sorting={sorting}
        onSortingChange={onSortingChange}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        rowHeight={56}
      />
    </div>
  );
});
